"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _oxygenConfig = require("@8x8/oxygen-config");
var _uuid = require("uuid");
var _Statistics = require("../styled/Statistics");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Statistics(_ref) {
  var data = _ref.data,
    testId = _ref.testId,
    theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Statistics.Container, {
    testId: testId
  }, data.map(function (item) {
    var statistics = item.statistics,
      label = item.label,
      hasError = item.hasError;
    return /*#__PURE__*/_react["default"].createElement(_Statistics.StatisticsBox, {
      key: (0, _uuid.v4)()
    }, /*#__PURE__*/_react["default"].createElement(_Statistics.StatisticsNumbers, {
      hasError: hasError
    }, statistics), /*#__PURE__*/_react["default"].createElement(_Statistics.StatisticsText, {
      hasError: hasError
    }, label));
  })));
}
Statistics.propTypes = {
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    statistics: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    hasError: _propTypes["default"].bool
  })).isRequired,
  theme: _propTypes["default"].object.isRequired,
  testId: _propTypes["default"].string
};
Statistics.defaultProps = {
  testId: 'CARD_STATISTICS'
};
var _default = (0, _oxygenConfig.withTheme)(Statistics, 'statistics');
exports["default"] = _default;